// The flag artwork for the kit's phone field (ContactField's flagUrl): the kit's one flag sprite, every country in
// one SVG (country-flag-icons, MIT), shared with every app that shows the field and fetched once when a flag shows.
import {spriteFlagUrl} from "@twoshot/ui-kit/phone/react";
import sprite from "@twoshot/ui-kit/phone-flags.svg?url";

export const flagUrl = spriteFlagUrl(sprite);
